import Decimal from 'decimal.js';

const withPrecision = (value: number, precision?: number) => (
  new Decimal(value).toSignificantDigits(precision).toNumber()
);

export default withPrecision;
